module.exports = __webpack_public_path__ + "static/media/vendor_management_filter_icon.2853812d.svg";